import { Component, Input, OnInit } from "@angular/core";

@Component({
	selector: "app-card-bon-sortie",
	templateUrl: "./card-bon-sortie.component.html",
})
export class CardBonSortieComponent implements OnInit {
	@Input() id: string;
	@Input() project: string;
	@Input() date: string;
	@Input() commantaire: string;
	@Input() magasinier: string;
	constructor() {}

	ngOnInit() {}
}
